export default __webpack_public_path__ + "static/media/job.6d596b91.png";